import { GenderMap } from '../job-posting/constants'
import { JobSearchTime } from './types'

export const WorkableHoursPerDayMap = {
  None: 0,
  One: 1,
  Two: 2,
  Three: 3,
  Four: 4,
  Five: 5,
  Six: 6,
  Seven: 7,
  Eight: 8,
  AllDay: 24,
}

export const WorkableHoursPerDayLabelMap = {
  [WorkableHoursPerDayMap.None]: '선택',
  [WorkableHoursPerDayMap.One]: '1시간',
  [WorkableHoursPerDayMap.Two]: '2시간',
  [WorkableHoursPerDayMap.Three]: '3시간',
  [WorkableHoursPerDayMap.Four]: '4시간',
  [WorkableHoursPerDayMap.Five]: '5시간',
  [WorkableHoursPerDayMap.Six]: '6시간',
  [WorkableHoursPerDayMap.Seven]: '7시간',
  [WorkableHoursPerDayMap.Eight]: '8시간',
  [WorkableHoursPerDayMap.AllDay]: '종일',
}

export const PreferDistanceMap = {
  ByWalk15: 'by_walk15',
  ByWalk30: 'by_walk30',
  ByKm3: 'by_km_3',
  ByKm5: 'by_km_5',
}

export const PreferDistanceLabelMap = {
  [PreferDistanceMap.ByWalk15]: '도보 15분 이내',
  [PreferDistanceMap.ByWalk30]: '도보 30분 이내',
  [PreferDistanceMap.ByKm3]: '반경 3KM 이내',
  [PreferDistanceMap.ByKm5]: '반경 5KM 이내',
}

export const PreferDistanceOptionsMap = [
  {
    value: PreferDistanceMap.ByWalk15,
    label: PreferDistanceLabelMap[PreferDistanceMap.ByWalk15],
  },
  {
    value: PreferDistanceMap.ByWalk30,
    label: PreferDistanceLabelMap[PreferDistanceMap.ByWalk30],
  },
  {
    value: PreferDistanceMap.ByKm3,
    label: PreferDistanceLabelMap[PreferDistanceMap.ByKm3],
  },
  {
    value: PreferDistanceMap.ByKm5,
    label: PreferDistanceLabelMap[PreferDistanceMap.ByKm5],
  },
]

export const PreferredGenderMap = {
  Male: [GenderMap.Male],
  Female: [GenderMap.Female],
  All: 'all',
}

export const PreferredGenderLabelMap = {
  [GenderMap.Female]: '여자',
  [GenderMap.Male]: '남자',
  [PreferredGenderMap.All]: '무관',
}

export const PreferWorkTypeMap = {
  All: 'all',
  Commute: 'commute',
  Resident: 'resident',
  BathHelp: 'bath_help',
  FamilyCare: 'family_care',
  DayCare: 'day_care',
  Facility: 'facility',
  Sanatorium: 'sanatorium',
  HomeNursing: 'home_nursing',
  Hospital: 'hospital',
  HospitialCompanion: 'hospital_companion',
  Etc: 'etc',
} as const

export const PreferWorkTypeLabelMap = {
  [PreferWorkTypeMap.Commute]: '방문 요양',
  [PreferWorkTypeMap.Resident]: '입주 요양',
  [PreferWorkTypeMap.BathHelp]: '방문 목욕',
  [PreferWorkTypeMap.FamilyCare]: '가족 요양',
  [PreferWorkTypeMap.DayCare]: '주야간보호소',
  [PreferWorkTypeMap.Sanatorium]: '요양원',
  [PreferWorkTypeMap.HomeNursing]: '간병인',
  [PreferWorkTypeMap.Hospital]: '병원',
  [PreferWorkTypeMap.HospitialCompanion]: '병원동행',
  [PreferWorkTypeMap.Etc]: '기타',
} as const

export const ExpectedAcquisitionMap = {
  None: 'none',
  First2022: '2022/05',
  Second2022: '2022/08',
  Third2022: '2022/11',
  NextYear2023: '2023',
} as const

export const ExpectedAcquisitionLabelMap = {
  [ExpectedAcquisitionMap.None]: '아직 시험 볼 계획이 없습니다.',
  [ExpectedAcquisitionMap.First2022]: '제 39회 / 2022년 5월',
  [ExpectedAcquisitionMap.Second2022]: '제 40회 / 2022년 8월',
  [ExpectedAcquisitionMap.Third2022]: '제 41회 / 2022년 11월',
  [ExpectedAcquisitionMap.NextYear2023]: '2023년에 시험 볼 예정입니다.',
}

export const StatusMap = {
  Draft: 'draft',
  Active: 'Active',
}

export const PossibleWorkMap = {
  Talk: 'talk',
  Walk: 'walk',
  Cook: 'cook',
  Clean: 'clean',
  HospitalWith: 'hospital_with',
  Wash: 'wash',
  Bath: 'bath',
  Diapers: 'diapers', // 기저귀 교환
  CognitiveStimulation: 'cognitive_stimulation',
  Rehabilitation: 'rehabilitation',
}

export const PossibleWorkLabelMap = {
  [PossibleWorkMap.Talk]: '말벗',
  [PossibleWorkMap.Walk]: '산책',
  [PossibleWorkMap.Cook]: '식사준비',
  [PossibleWorkMap.Clean]: '청소/정리',
  [PossibleWorkMap.HospitalWith]: '병원동행',
  [PossibleWorkMap.Wash]: '세면도움',
  [PossibleWorkMap.Bath]: '목욕도움',
  [PossibleWorkMap.Diapers]: '기저귀교체',
  [PossibleWorkMap.CognitiveStimulation]: '인지자극활동',
  [PossibleWorkMap.Rehabilitation]: '재활도움',
}

export const JobSearchTimeMap = {
  Morning: 'morning',
  EarlyAfternoon: 'early_afternoon',
  LateAfternoon: 'late_afternoon',
  Evening: 'evening',
  Others: 'others',
} as const

export const JobSearchTimeHourMap: Record<JobSearchTime, readonly [number, number]> = {
  [JobSearchTimeMap.Morning]: [8, 12],
  [JobSearchTimeMap.EarlyAfternoon]: [12, 15],
  [JobSearchTimeMap.LateAfternoon]: [15, 18],
  [JobSearchTimeMap.Evening]: [18, 24],
  [JobSearchTimeMap.Others]: [0, 0],
} as const

export const JobSearchTimeLabelMap = {
  [JobSearchTimeMap.Morning]: '오전 근무(오전 8시~12시)',
  [JobSearchTimeMap.EarlyAfternoon]: '오후 근무(오후12시~3시)',
  [JobSearchTimeMap.LateAfternoon]: '오후 근무(오후3시~6시)',
  [JobSearchTimeMap.Evening]: '저녁 근무(오후 6시 이후)',
  [JobSearchTimeMap.Others]: '기타',
} as const

export const WorkingHourMap = {
  Normal: 'normal',
  OneShift: 'one_shift',
  TwoShift: 'two_shift',
  ThreeShift: 'three_shift',
} as const

export const WorkingHourLabelMap = {
  [WorkingHourMap.Normal]: '평일 주간 근무',
  [WorkingHourMap.OneShift]: '3조 1교대 근무(퐁당당)',
  [WorkingHourMap.TwoShift]: '3조 2교대 근무(주주야야비비)',
  [WorkingHourMap.ThreeShift]: '3조 3교대 근무',
} as const

export const CareerMap = {
  None: 'none',
  SixMonth: 'six_month',
  OneYear: 'one_year',
  TwoYear: 'two_year',
  ThreeYear: 'three_year',
  FourYear: 'four_year',
  FiveYear: 'five_year',
} as const

export const CareerLabelMap = {
  [CareerMap.None]: '없음',
  [CareerMap.SixMonth]: '6개월 이하',
  [CareerMap.OneYear]: '1년 이하',
  [CareerMap.TwoYear]: '2년 이하',
  [CareerMap.ThreeYear]: '3년 이하',
  [CareerMap.FourYear]: '4년 이하',
  [CareerMap.FiveYear]: '5년 이상',
} as const

export const JobSearchStatusMap = {
  Actively: 'actively',
  Commonly: 'commonly',
  Working: 'working',
  Off: 'off',
} as const

export const JobSearchStatusLabelMap = {
  [JobSearchStatusMap.Actively]: '적극 구직중',
  [JobSearchStatusMap.Commonly]: '구직 중',
  [JobSearchStatusMap.Working]: '구직 완료 (근무중)',
  [JobSearchStatusMap.Off]: '구직 의사 없음',
} as const

export const JobSearchStatusValueMap = {
  [JobSearchStatusMap.Actively]: 0,
  [JobSearchStatusMap.Commonly]: 1,
  [JobSearchStatusMap.Off]: 2,
  [JobSearchStatusMap.Working]: 3,
} as const
